import { BreakdownEntry } from './useScoringEvents';

export const chipTypeMap: Record<string, CMxCommonApp.ChargeSessionCodeType> = {
  PROCEDURE: 'procedure',
  DIAGNOSIS: 'diagnosis',
  MODIFIER: 'modifier'
};

export const RESOLVER_TO_BREAKDOWN_TYPE: Record<string, string> = {
  PROCEDURE: 'cpt',
  DIAGNOSIS: 'icd',
  MODIFIER: 'modifier'
};

export function findDeduction(
  c: CQA.ResolverCodeDto,
  breakdown: BreakdownEntry[]
): BreakdownEntry | undefined {
  const codeType = RESOLVER_TO_BREAKDOWN_TYPE[c.codeType];
  return breakdown.find(
    e => e.codeType === codeType && e.codeValue === c.code && e.rubricPoints > 0.001
  );
}
